import PropTypes from "prop-types"
import React, { useContext } from "react"
import { Textarea } from "atomize"
import { theme } from "../settings/config"

TextArea.propTypes = {
	handleChange: PropTypes.func,
	placeholder: PropTypes.string,
	value: PropTypes.string,
}

TextArea.defaultProps = {
	placeholder: "",
	value: "",
	handleChange: null,
}

function TextArea({ placeholder, value, handleChange }) {
	return (
		<Textarea
			bg={theme.colors.surface}
			m={{ y: "1rem" }}
			p="1rem"
			border="3px solid"
			borderColor={theme.colors.surface}
			focusBorderColor={theme.colors.gunmetal}
			rounded="20px"
			placeholder={placeholder}
			value={value}
			onChange={e => handleChange(e)}
		/>
	)
}

export default TextArea
